import Panel from "components/panels/panel";
import React from "react";
import { useLoaderData } from "react-router";

export const ArticleContent = () => {
  const viewModel = useLoaderData<server.viewmodel.ArticleContentFrontModel>();

  const translation = viewModel.translation;

  return <Panel
    panelClassName="s1_panel"
  >
    <article
      dangerouslySetInnerHTML={{
        __html: "<h1>" + translation.title + "</h1>" + translation.content
      }}
    />
  </Panel>
}